<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.smeltingProductionResult") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingProductionResult"><span>{{$t('tlt.smeltingProductionResult')}}</span></router-link></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('smeltingProductionResult')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>                       
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div> -->
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.planCode") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="planCodeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.locName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="plantFilter"/>
                                </div>                                 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.shift") }} :
                                    </label>
                                    <select class="form-control" type="text" v-model="shiftFilter">
                                        <option value>{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="甲">{{ $t("lbl.shift.A") }}</option>
                                        <option value="乙">{{ $t("lbl.shift.B") }}</option>  
                                        <option value="丙">{{ $t("lbl.shift.C") }}</option>
                                    </select>
                                </div>                               
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="startDayFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="endDayFilter"></mmf-datepicker>
                                </div>  
                                <div class="col-lg-2 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('smeltingProductionResult')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('smeltingProductionResult')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="smeltingProductionResultResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="smeltingProductionResult" inline-actions-disabled :singleChoice='true' :buttons="buttons">
                                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="jumpToSmeltMatCost(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.prd.execution.matCost')}}</span>                                         
                                    </button> 
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="jumpToSmeltEnergyCost(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.prd.execution.energyCost')}}</span>                                         
                                    </button>   
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="jumpToSmeltProductInfo(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.prd.execution.productInfo')}}</span>                                         
                                    </button>   
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="jumpToSmeltProductQuality(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.prd.execution.productQuality')}}</span>                                         
                                    </button>  
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="jumpToSmeltEquipPara(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.prd.execution.equipPara')}}</span>                                         
                                    </button>   
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>        
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionExecution/smelting/SmeltingProductionResult";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from '@/components/MmfDatepicker';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'smeltingProductionResult/getField',
    mutationType: 'smeltingProductionResult/updateField',
});

export default {
  name: "smeltingProductionResultList",
  data () {
    return {
        buttons: [{
                methodName: "updateData",
                name: "刷新数据",
                variant:"outline-primary"
            }]
    }
  },
  components: { MmfTable, MmfDatepicker},
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.smeltingProductionResult.rows,
            checkedItems: state => state.smeltingProductionResult.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields,
            entity: state => state.smeltingProductionResult.entity
        })
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),
    ...mapActions("smeltingProductionResult", ["jumpToSmeltEnergyCost", "jumpToSmeltMatCost", "jumpToSmeltProductInfo", "jumpToSmeltProductQuality", "jumpToSmeltEquipPara"]),
    
    updateData(row) {
        this.$store.dispatch("smeltingProductionResult/updateData", row)
    }
  },
  mounted(){
  }
};
</script>
